<script>
/* Imports */
import { mapGetters } from 'vuex';

export default {
  name: 'EmailSubscribe',
  props: {
    productHeaderDetails: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      scriptCategory: '',
      scriptSubcategory: '',
      scriptSource: '',
      scriptConsentTypeId: '',
      headerDetailsHtml: '',
    };
  },
  computed: {
    ...mapGetters({
      partNumber: 'getPartNumber',
      locale: 'getLocale',
    }),
    showEmailSignup() {
      // Check if all required script details are set
      return this.scriptCategory && this.scriptSource && this.scriptConsentTypeId;
    },
  },
  watch: {
    partNumber() {
      this.setHeaderDetails();
    },
  },
  mounted() {
    this.setHeaderDetails();
  },
  methods: {
    setHeaderDetails() {
      // Use regex to grab the script source
      // eslint-disable-next-line prefer-regex-literals
      const script = new RegExp('src="(.*?)"').exec(this.productHeaderDetails);

      // If there's no script, we still need to render the html element
      if (!script) {
        this.headerDetailsHtml = this.productHeaderDetails;
        return;
      }

      const scriptSrc = script[1];

      const url = new URL(scriptSrc);

      this.scriptCategory = url.searchParams?.get('category');
      this.scriptSubcategory = url.searchParams?.get('subcategory');
      this.scriptSource = url.searchParams?.get('source');
      this.scriptConsentTypeId = url.searchParams?.get('consentTypeId');
    },
  },
};
</script>

<template>
  <authorable-email-signup
    v-if="showEmailSignup"
    :category="scriptCategory"
    :subcategory="scriptSubcategory"
    client-id="ITW_PRODUCT_PAGE"
    :consent-type-id="scriptConsentTypeId"
    :locale="locale"
    :source="scriptSource"
  />
  <g-copy
    v-if="headerDetailsHtml"
    type="small"
    v-html="headerDetailsHtml"
  />
</template>
